import { defineResolver } from 'customer-flows/utils/quote/resolvers'

export default {
  customer: defineResolver<PersonInput>(({ resolveStoreProp }) => ({
    resolve: () => {
      return {
        name: resolveStoreProp('customer', 'name'),
        email: resolveStoreProp('customer', 'email'),
        phone: resolveStoreProp('customer', 'phone')
      }
    },
    traits: {
      withMarketingOptin: (resolved) => {
        return {
          ...resolved,
          optinMarketing: resolveStoreProp('customer', 'optinMarketing')
        }
      },
      withSmsOptin: (resolved) => {
        return {
          ...resolved,
          optinSms: resolveStoreProp('customer', 'optinSms')
        }
      },
      withGdpr: (resolved) => {
        return {
          ...resolved,
          isGdpr: resolveStoreProp('application', 'isGdpr')
        }
      }
    }
  }))
}
